<div *ngIf="isVisible">
    <div class="empty-card">
        <div class="img-container">
            <img [src]="icon" alt="icone">
        </div>

        <h3>{{title}}</h3>
        <p [style.maxWidth]="large ? '600px' : '300px'">
            {{description}}
        </p>

        <ng-container *ngIf="buttonLabel">
            <app-button (click)="click($event)"
                [class.add-button]="haveButtonIcon">
                <svg-icon src="assets/images/icon-add.svg" class="mr-2"
                    *ngIf="haveButtonIcon"></svg-icon>{{buttonLabel}}
            </app-button>
        </ng-container>
    </div>
</div>